<template>
    <div class="app-container">
      <SidebarItems />
      
    </div>
  </template>
  
  <script>
  import SidebarItems from './SidebarItems.vue';
  
  export default {
    name: 'MainPage',
    components: {
      SidebarItems,
    },
  };
  </script>
  
  <style>
  .app-container {
    display: flex;
  }
  
  .main-content {
    flex-grow: 1;
    padding: 20px;
  }
  </style>